import React from "react";

import {
  ModalContent,
  ModalRoot,
} from "@replo/design-system/components/modal/Modal";

interface ImageOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  imageSrc: string;
  imageAlt: string;
}

export const ImageOverlay: React.FC<ImageOverlayProps> = ({
  isOpen,
  onClose,
  imageSrc,
  imageAlt,
}) => {
  return (
    <ModalRoot
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <ModalContent
        showCloseButton={false}
        size="lg"
        UNSAFE_className="bg-transparent p-0 shadow-none border-0 w-fit rounded-none"
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg"
        />
      </ModalContent>
    </ModalRoot>
  );
};
